module.exports = __webpack_public_path__ + "static/ecommerce-dashboards-context-25e66b63272a355605d232f96a7cb101.png";